(function () {
  /**
   * @awaitingdeprecation
   *
   * @ngdoc provider
   * @name binky.core.api.jil:jilInvoicesProvider
   * @description defines service to get jil invoices resources
   */
  angular.module('binky.core.api.jil').provider('jilInvoices', jilInvoicesProvider);

  let url;

  /* @ngInject */
  function jilInvoicesProvider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/organizations`;
    }

    /* @ngInject */
    function $get($resource, apiUtils) {
      const service = {
        invoices: getInvoiceResource(),
      };

      return service;

      ///////////

      function getInvoiceResource() {
        return $resource(`${url}/:orgId/invoices`, {
          orgId: apiUtils.getActiveOrg,
        });
      }
    }
  }
})();
